<div class="dx-field">
  <div class="dx-field-label w-50">{{ 'nextPIM Objekt-Ids verwenden' }}</div>
  <dx-switch [(value)]="useObjectIds"></dx-switch>
</div>
